import { Split } from '../split';
export class LegendComponent extends Split {
}
//# sourceMappingURL=component.js.map